export default "__VITE_ASSET__CwOeliwF__"